import React, { useState } from 'react'
import { useHistory } from 'react-router'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import _ from 'lodash'
import { Button, Icon } from '@qure/containers'
import miscUtils from 'libs/miscUtils'
// import getAppVersion from 'libs/getAppVersion'

import ChangePasswordModal from '../../ChangePasswordModal'

const UserSettingsDropdown = props => {
  const { onLogout, t, userProfile } = props
  const [isOpen, setIsOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const history = useHistory()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const onOpenModal = () => {
    setIsModalOpen(true)
  }

  const onCloseModal = () => {
    setIsModalOpen(false)
  }

  const settingClass = classNames('dropdown is-up is-hoverable ', {
    'is-active': isOpen
  })

  const IS_MWL_ENABLED = miscUtils.getMwlState()
  const IS_REMOTE_ACCESS_ENABLED = _.get(userProfile, ['remote_access'], false)

  return (
    <div className={settingClass}>
      <div
        role="button"
        tabIndex="0"
        className="dropdown-trigger"
        onClick={toggleMenu}
        onKeyDown={toggleMenu}
      >
        <Icon iConClass="fa-cog" size="medium" sizeBooster="2x" />
      </div>
      <div className="dropdown-menu" id="dropdown-menu7" role="menu">
        <div className="dropdown-content">
          <div className="dropdown-item">
            <Button
              type="button"
              onClick={() => onLogout(true)}
              className="is-text is-fullwidth has-text-primary"
            >
              <Icon iConClass="fa-sign-out-alt" />
              <span>{t('Logout')}</span>
            </Button>
          </div>
          <div className="dropdown-item">
            <Button
              type="button"
              onClick={onOpenModal}
              className="is-text is-fullwidth has-text-primary"
            >
              <Icon iConClass="fa-lock" />
              <span>{t('Change password')}</span>
            </Button>
            <ChangePasswordModal
              isOpen={isModalOpen}
              onClose={onCloseModal}
              isAdmin={false}
            />
          </div>
          {IS_MWL_ENABLED && (
            <div className="dropdown-item">
              <Button
                className="is-text is-fullwidth has-text-primary"
                onClick={() => {
                  history.push('/scp')
                }}
              >
                <Icon iConClass="fa-computer-classic" />
                <span>{t('Configure modality')}</span>
              </Button>
            </div>
          )}
          {IS_REMOTE_ACCESS_ENABLED && (
            <div className="dropdown-item">
              <Button
                className="is-text is-fullwidth has-text-primary"
                onClick={() => {
                  window.open('qureai://qtrack-wifi-connect-window', '_blank')
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  style={{
                    widows: '20px',
                    height: '20px',
                    marginRight: '10px'
                  }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"
                  />
                </svg>
                <span>{t('Remote access')}</span>
              </Button>
            </div>
          )}
          <hr className="dropdown-divider" />
          <div className="dropdown-item">
            <a
              href="/terms-and-conditions-en.html"
              target="_blank"
              rel="noreferrer"
            >
              <Icon iConClass="fa-external-link-alt" />
              {t('Terms and conditions')}
            </a>
          </div>
          {/* <div className="dropdown-item app-version">{getAppVersion()}</div> */}
        </div>
      </div>
    </div>
  )
}

UserSettingsDropdown.propTypes = {
  onLogout: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  userProfile: PropTypes.object.isRequired
}

export default UserSettingsDropdown
